module.exports = __webpack_public_path__ + "img/icon-closex.dd088e23.svg";